import { MdDragIndicator } from 'react-icons/md';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { StatusGroup } from '@/store/cases-board.store';
import { CaseStatus } from '@/api/apis/case';
import { useCaseStatusCountForRow } from '@/queries/case';

export type StatusCardProps = {
  id: string;
  title: string;
  status?: CaseStatus;
  group?: StatusGroup;
};

export const StatusCard = ({ id, title, status, group }: StatusCardProps) => {
  const count = useCaseStatusCountForRow({ status, group });

  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 1 : 0,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="flex w-full items-center cursor-pointer py-2"
      {...attributes}
      {...listeners}
    >
      <MdDragIndicator size={24} />
      <div className="flex flex-1 h-10 bg-base-70 items-center justify-between px-3 py-2 rounded-lg">
        <div className="text-l-m">{title}</div>
        <div className="text-m-r text-base-20 ml-2">{count ?? 0} cases</div>
      </div>
    </div>
  );
};
